export default "__VITE_ASSET__98180c72__"